import { nonOpsHdrStateCheckboxOption } from "presentation/constant/CheckBox/StaticCheckboxOptions";
import { billingCycleDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ManualChargeConstant } from "presentation/constant/ManualCharge/ManualChargeConstant";
import { NonOpsConstant } from "presentation/constant/NonOps/NonOpsConstant";
import { useNonOpsHeaderVM } from "presentation/hook/NonOps/useNonOpsHeaderVM";
import { useNonOpsHeaderTracked } from "presentation/store/NonOps/NonOpsHeaderProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, GroupCheckboxList, HPHGroupCheckbox, IFieldValue } from "veronica-ui-component/dist/component/core";

const NonOpsHeaderSearchForm = () => {
    const [nonOpsHdrState] = useNonOpsHeaderTracked();
    const nonOpsHdrVM = useNonOpsHeaderVM();
    const NON_OPS_HDR_CONST = NonOpsConstant.Header;
    const MAN_CHG_HDR_CONST = ManualChargeConstant.Header;
    const headerSearchCriteria = nonOpsHdrState.searchCriteria;


    const memoBillingCycle = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%", marginBottom: "24px" }}>

            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria?.billingCycleList?.join(',')}
                fieldValue={headerSearchCriteria?.billingCycleList}
                fieldLabel={NON_OPS_HDR_CONST.BILLING_CYCLE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billingCycleList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={billingCycleDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsHdrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [NON_OPS_HDR_CONST.BILLING_CYCLE, headerSearchCriteria.billingCycleList, nonOpsHdrVM])

    const memoState = useMemo(() =>
        // <div className='flex-row-item' style={{ columnGap: '30px' }}>
        <div className='flex-row-item'>
            <HPHGroupCheckbox
                label={MAN_CHG_HDR_CONST.STATE}
                checkboxData={nonOpsHdrStateCheckboxOption}
                selectedValues={headerSearchCriteria.stateList}
                orientation={"horizontal"}
                onChange={(e: (GroupCheckboxList | undefined)[]) => nonOpsHdrVM.onGroupCheckboxChange(e, headerSearchCriteria, "stateList")}
            />
        </div>
        , [MAN_CHG_HDR_CONST.STATE, headerSearchCriteria, nonOpsHdrVM])

    const memoCustCode = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria?.customerCodeList?.join(',')}
                fieldValue={headerSearchCriteria?.customerCodeList}
                fieldLabel={NON_OPS_HDR_CONST.CUST_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={nonOpsHdrState.dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsHdrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [NON_OPS_HDR_CONST.CUST_CODE, headerSearchCriteria.customerCodeList, nonOpsHdrState.dynamicOptions.customerCodeDropdownOptions, nonOpsHdrVM])

    const memoRefNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '190px', width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria.refNo || ''}
                fieldValue={headerSearchCriteria.refNo}
                fieldLabel={NON_OPS_HDR_CONST.REF_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'refNo'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsHdrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [NON_OPS_HDR_CONST.REF_NO, headerSearchCriteria.refNo, nonOpsHdrVM])

    const memoInvCreditNoteNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '190px', width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria.invCreditNoteNo || ''}
                fieldValue={headerSearchCriteria.invCreditNoteNo}
                fieldLabel={NON_OPS_HDR_CONST.INV_CR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'invCreditNoteNo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsHdrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [NON_OPS_HDR_CONST.INV_CR_NO, headerSearchCriteria.invCreditNoteNo, nonOpsHdrVM])

    const menoStdBill = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '190px', width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={headerSearchCriteria.stdBill || ''}
                fieldValue={headerSearchCriteria.stdBill}
                fieldLabel={NON_OPS_HDR_CONST.STD_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'stdBill'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    nonOpsHdrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [NON_OPS_HDR_CONST.STD_BILL, headerSearchCriteria.stdBill, nonOpsHdrVM])

    const memoCreatedDateFromTo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: '190px', maxWidth: '410px', width: "100%", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={MAN_CHG_HDR_CONST.CREATED_DATE_RANGE}
                width='100%'
                fieldNames={{ startField: "createdDateFrom", endField: "createdDateTo" }}
                dateRange={{ startDate: headerSearchCriteria.createdDateFrom, endDate: headerSearchCriteria.createdDateTo }}
                onDatesChange={nonOpsHdrVM.onDateRangeChange}
            />
        </div>
        , [MAN_CHG_HDR_CONST.CREATED_DATE_RANGE, headerSearchCriteria.createdDateFrom, headerSearchCriteria.createdDateTo, nonOpsHdrVM.onDateRangeChange])


    return <>

        <CriteriaItemContainer>
            {memoState}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoRefNo}
            {menoStdBill}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoBillingCycle}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoCustCode}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoInvCreditNoteNo}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoCreatedDateFromTo}
        </CriteriaItemContainer>
    </>;
}
export default memo(NonOpsHeaderSearchForm);